function methods(type) {
  const store = window[type];

  return {
    setItem(key, value) {
      store.setItem(key, JSON.stringify(value));
    },

    getItem(key) {
      try {
        return JSON.parse(store.getItem(key));
      } catch (e) {
        return undefined;
      }
    },

    removeItem(key) {
      store.removeItem(key);
    },

    hasItem(key) {
      return store.hasOwnProperty(key);
    }
  };
}

export const inPersistentStore = {
  ...methods('localStorage'),
};

export const inTemporaryStore = {
  ...methods('sessionStorage'),
};